/* Homepage presentation only; preserve native editing and other shortcuts. */
(() => {
  const isEditable = (node) =>
    node instanceof HTMLElement && (node.matches('input, textarea, select') || node.isContentEditable);

  const isEditing = (event) => {
    if (event.composedPath().some(isEditable)) return true;

    let active = document.activeElement;
    while (active) {
      if (isEditable(active)) return true;
      active = active.shadowRoot?.activeElement;
    }
    return false;
  };

  // Delegation also covers images replaced by the Theme Editor.
  document.addEventListener('dragstart', (event) => {
    if (isEditing(event)) return;
    const imageDrag = event.composedPath().some((node) =>
      node instanceof HTMLImageElement || (node instanceof HTMLAnchorElement && node.querySelector('img'))
    );
    if (imageDrag) event.preventDefault();
  }, { capture: true });

  document.addEventListener('keydown', (event) => {
    if (
      event.defaultPrevented || event.isComposing || event.altKey || event.shiftKey ||
      !(event.ctrlKey || event.metaKey) || event.key.toLowerCase() !== 'a' || isEditing(event)
    ) return;

    event.preventDefault();
  });
})();
